import { api } from './client';

/**
 * Список дел ученика: задания от куратора с периодичностью.
 *
 * ⚠️ ДО 01.09.2026 ЭТО БЫЛ ХАРДКОД. Три пункта, зашитых в код, — одни и те же у
 * всех и каждый день, — а галочки лежали в памяти браузера: отметил на телефоне,
 * на ноутбуке пусто; почистил браузер — пропали; куратор не видел их вовсе.
 */
export type DailyTaskKind = 'section' | 'lesson' | 'text';

export type DailyTask = {
  id: string;
  title: string;
  kind: DailyTaskKind;
  target: string;
  done: boolean;
};

export const dailyTasksApi = {
  /** Что у ученика сегодня. Курсы и группы передаются так же, как для календаря. */
  today: (scope?: { marathonIds?: string[]; groupIds?: string[] }) => {
    const params = new URLSearchParams();
    (scope?.marathonIds ?? []).forEach((m) => params.append('marathon_id', m));
    (scope?.groupIds ?? []).forEach((g) => params.append('group_id', g));
    return api
      .get<{ items: DailyTask[] }>('/student/daily-tasks', { params })
      .then((r) => r.data?.items ?? []);
  },

  toggle: (id: string) =>
    api.post<{ done: boolean }>(`/student/daily-tasks/${id}/toggle`).then((r) => r.data),
};

/**
 * Куда ведёт нажатие на задание.
 *
 * ⚠️ У задания-строки перехода нет намеренно: «повторить неправильные глаголы» —
 * это напоминание, а не экран. Ссылка в никуда хуже её отсутствия.
 */
export function taskLink(task: Pick<DailyTask, 'kind' | 'target'>): string | null {
  if (task.kind === 'text') return null;
  const target = task.target?.trim();
  if (!target) return null;
  // 🔴 БЫЛО `/app/lesson/` — В ЕДИНСТВЕННОМ ЧИСЛЕ, а маршрут `/app/lessons/:id`.
  // Каждое задание-урок вело на «404, страница не найдена». Такую ошибку не
  // поймает ни компилятор, ни сборка: это просто строка, и видит её только тот,
  // кто по ней пройдёт, — ученик. Найдено 05.09.2026 вместе с той же бедой у
  // раздела «Словарь» (`/app/vocab` вместо `/app/vocabulary`).
  if (task.kind === 'lesson') return `/app/lessons/${target}`;
  // Раздел приложения куратор выбирает из списка, поэтому здесь уже готовый
  // путь. Чужой адрес во внутренний переход не пускаем (`//host` — это уже другой сайт).
  return target.startsWith('/') && !target.startsWith('//') ? target : null;
}
